import { Component, OnInit } from '@angular/core';
import { Claim } from 'src/app/models/claim';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-printer-header',
  templateUrl: './printer-header.component.html',
  styleUrls: ['./printer-header.component.css'],
  imports: [
    CommonModule,
    TranslateModule
  ],
  standalone: true
})
// This class is responsible for printing header on Print page.
export class PrinterHeaderComponent implements OnInit {

  submitionDate: any;
  submitionTime: any;
  month: any;

  constructor() {
    const claim: Claim = localStorage.getItem('claimPrint') ? JSON.parse(localStorage.getItem('claimPrint')) : {};
    if (claim.submitionDate && localStorage.getItem('currentLang') === 'en') {
      this.submitionDate = moment(claim.submitionDate).format('YYYY-MM-DD');
      this.submitionTime = moment(claim.submitionDate).format('hh:mm a');
    }
    else if (claim.submitionDate && localStorage.getItem('currentLang') === 'fr') {
      this.submitionDate = moment(claim.submitionDate).format('YYYY-MM-DD');
      this.submitionTime = moment(claim.submitionDate).format('HH') + ' h ' + moment(claim.submitionDate).format('mm');
    }
  }

  ngOnInit(): void {
  }

}
